import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { GENERATE_OTP_SCH, GET_DDA_DETAILS, GET_METADATA_SCH, GET_RELOAD_DETAILS, STATUS_SUCCESS_CODE, VALIDATE_SECONDARY_CARD_SSN, CREATE_SCH_CARD , GET_CARDHOLDER_CARDS} from '../../../../../network/URLConstants';
import { useDispatch, useSelector } from 'react-redux';
import { appTheme, retrieveData } from '../../../../../helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from '../../../../../network/NetworkUtils';
import { withOidcSecure } from '@axa-fr/react-oidc';
import HomeLayout from '../../../../Layout/HomeLayout';
import HomeHeader from '../../../../CustomComponents/HomeHeader';
import DynamicCard from '../../../../CustomComponents/DynamicCard';
import { width, height } from '../../../../CustomComponents/DynamicCard/DynamicCardStyles';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import CardHeading from '../../../../CustomComponents/CardHeading';
import { addLineBreaks } from '../../../../../utils';
import CustomTextInput from '../../../../CustomComponents/CustomtextInput';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { displayErrorMessage , displayErrorMessageSCHSSN} from '../../../../../utils';
import { PostRequest } from '../../../../../network/NetworkUtils';
import Modal from '../../../../CustomComponents/Modal';
import ErrorModalForSSN from './ErrorModalForSSN';
import Loader from '../../../../CustomComponents/Loader';
import { validateMobileNumberForSCH } from '../../../../../utils';
import CustomDropdown from '../../../../CustomComponents/CustomDropDown';
import { isEmailValid } from '../../../../../utils';
import SuccessModalForSSN from './SuccessModalForSSN';
import Custom2FA from '../../../../CustomComponents/Custom2FA';
import HideSSNPic from '../../../../../assets/images/hidepassword.png'
import { set } from 'react-hook-form';
import { formatDateOfBirthForUi , formatDateToDDMMYYYYFORSCH} from '../../../../../helpers/utils/Utils';
import { formatDateYYYYMMDD , formatDateYYYYMMDDFORSCH} from '../../../../../utils';
import { personalFormatPhoneNumber } from '../../../../../utils';
import { displayKudzuplusErrorMessage } from '../../../../../utils';
import { LOGIN_SESSION_KEY } from '../../../../../Redux/reducers';
import SuccesModalForSCH from './SuccesModalForSCH';
import Check from '../../../../../assets/images/Check.png';
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle';


const AddSecondaryCardHolder = () => {
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_add_secondary_cardholder'));
    
    const navigate = useNavigate();
    const cards = useSelector(state => JSON.parse(state.userCards));
    const dispatch = useDispatch()
    const currentpath = useLocation()
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)
    const InputStyles = "font-hanken-grotesk px-4 lg:text-[16px] md:text-[15px] text-[14px] placeholder:font-semibold font-medium focus:outline-none w-full h-[60px]";
    const [steps, setSteps] = useState(1)
    const firstName = useSelector(x => x.secondaryCardFirstName)
    const lastName = useSelector(x => x.secondaryCardLastName)
    const dob = useSelector(x => x.secondaryCardDob)
    const ssnFromRedux = useSelector(x => x.secondaryCardSsn)
    const phoneNumberSCH = useSelector(x => x.secondaryCardPhoneNumber)
    const carriersForSCH = useSelector(x => x.secondaryCardCarriers)
    const schEmail = useSelector(x => x.secondaryCardEmail)
    const MetadatCardTypes = useSelector(x => x.SecondCardTypes)
    const schSelectedCardType = useSelector(x => x.secondaryCardCardTypes)
    
    const schPrimaryAddressText = useSelector(x => x.schPrimaryCardAddress)
    const addOnCardRequestId = useSelector(x => x.schAddOnCardId)
    const [firstNameError, setFirstNameError] = useState()
    const [lastNameError, setLastNameError] = useState("")
    const [dobError, setDobError] = useState("")
    const [ssn, setSSN] = useState("")
    const [addressError, setAddressError] = useState("")
    const [ssnBackup, setSSNBackup] = useState("")
    const [isCursorVisible, setCursorVisibility] = useState(false)
    const [showSSN, setShowSSN] = useState(false)
    const [ssnError, setSsnError] = useState("")
    const selectedItem = cards?.find(card => card.AccountTypeBit63 === 1);
    const accessToken = useSelector((state) => state.accessToken);
    const [apisErrorModal, setApisErrorModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [showErrorMsg, setShowErrorMessage] = useState("")
    const [mobileCarriers, setMobileCarrires] = useState([])
    const [showMobileError, setShowMobielError] = useState("")
    const [errorModalForGenerateOTP , setErrorModalForGenrateOTP] = useState(false)
    const [showGenrateOTPErrorMessage, setShowGenerateOTPErrorMessage] = useState('')
    const [ssnSuccessModal, setSsnSuccessModal] = useState("");
    const [ssnResponseDataFromChild, setSsnResponseDataFromChild] = useState("");
    const [selectedMobileCarries, setSelectedMobileCarriers] = useState({
        Type: "",
        Name: ""
    },);
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const [showEmailErrorMessage, setEmailErrorMessage] = useState()
    const HeadingStyles =
        "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--oops-edit-clr)]";
    const SubHeadingStyles =
        "font-serif-pro modal-title lg:text-[33px] md:text-[33px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-edit-spendsense)] md:w-[80%]";

    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";

    
    const filteredCards = cards?.filter(x => x.AccountTypeName === "Shared" || x.AccountTypeName === "Nonshared")


    //Validae SSN    
    const handleStepTwoNextClick = async () => {
        if (!firstName || firstName.trim().length === 0) { setFirstNameError('Please enter first name'); return; }
        if (!lastName || lastName.trim().length === 0) { setLastNameError('Please enter last name'); return; };
        if (!dob) { setDobError('Please select date of birth'); return; };
        if (ssnBackup.length !== 9) {
            setSsnError('The SSN cannot be modified once submitted at the end of sign up.');
            return;
        }
        setIsLoading(true)
        const ssnBodyData = {
            "ssn": ssnFromRedux
        }
        const deviceId = await retrieveData("updatedDeviceId");
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = VALIDATE_SECONDARY_CARD_SSN(selectedItem.CardKey)
        try {
            const response = await PostRequest(url, ssnBodyData, headers);
            const responseJson = JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                setSteps(3)
                setIsLoading(false)
            } else {
                var arrMessages = responseJson.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setShowErrorMessage(displayText)
                setIsLoading(false)
                setApisErrorModal(true)
            }
        } catch (error) {
            setApisErrorModal(true)
            setIsLoading(false)
        }

    }
  

    const handleSSNBlur = () => {
        if (!ssnFromRedux || ssnFromRedux.length !== 9) {
            setSsnError('The SSN cannot be modified once submitted at the end of sign up.');
        } else {
            setSsnError('');
        }
    }

    const handleSteptwoBackClick = () => {
        setSteps(1)
    }


    const handleStepThreeBackClick = () => {
        setSteps(2)
    }


    const handleOnBlur = (e) => {
        if (!firstName || firstName.trim().length === 0) setFirstNameError('Please enter first name');
        else setFirstNameError('')
    }

    const handleLastNameBlur = () => {
        if (!lastName || lastName.trim().length === 0) setLastNameError('Please enter last name');
        else setLastNameError('')
    }

    const formatSSNValue = (value) => {
        const formattedValue = value
            .replace(/\D/g, '')
            .replace(/(\d{3})(\d{2})(\d{1,2})/, '$1 - $2 - $3');
        return formattedValue;
    }
    const formatSecuredSSNValue = (value) => {
        const securedValue = value
            .replace(/[^0-9•]/g, '')
            .replace(/((?:\d|.){3})((?:\d|.){2})((?:\d|.){1,2})/, '$1 - $2 - $3')
            .replace(/[0-9]/g, '•');
        return securedValue;
    }
    const handleSSNChange = (event) => {
        const raw = event.target.value.replace(/[*-]/g, '').replace(/\D/g, '');
        if (raw.length <= 9) {
            setSSNBackup(raw);
            const display = showSSN ? formatSSNValue(raw) : formatSecuredSSNValue(raw);
            setSSN(display);
            setSsnError('');
            dispatch({ type: 'SECONDARY_CARD_SSN', payload: { secondaryCardSsn: raw } });
        }
    }
    const toggleCursor = () => setCursorVisibility(!isCursorVisible)

    const toggleShowSSN = () => {
        const next = !showSSN;
        const display = next ? formatSSNValue(ssnBackup) : formatSecuredSSNValue(ssnBackup);
        setShowSSN(next);
        setSSN(display);
    }

    const handleStepOneClicked = () => {
        setSteps(2)
    }

    const handleSsnErrorCloseModal = () => {
        setApisErrorModal(false)
    }

      const handlegGenerateOTPErrorCloseModal = () => {
        setErrorModalForGenrateOTP(false)
    }

      const handleCloseFinalAPIErrorModal = () => {
        setShowFinalAPIErrorModal(false)
    }


    const handleSsnSuccessCloseClicked = () => {
        setSsnSuccessModal(false)
    }

      const handleSCHSuccessCloseClicked = () => {
        setShowSCHSuccessModal(false)
    }


    const handleAddressBlur = () => {
        if (!schPrimaryAddressText || schPrimaryAddressText.trim().length === 0) setLastNameError('Please enter addres');
        else setAddressError('')
    }

    const [metaDataResponse , setMetaDataRepsonse] = useState()
    // Get Metadata call
    const getMetaDataResponse = async () => {
        setIsLoading(true)
        const deviceId = await retrieveData("updatedDeviceId");
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = GET_METADATA_SCH(selectedItem?.CardKey)
        try {
            const response = await GetRequest(url, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                // Mobile Carriers
                setMetaDataRepsonse(responseJson.Response)
                const carriers = responseJson.Response.MobileCarriers;
                const transFormedCarriersList = carriers.map(con => ({
                    Type: con.Code,
                    Name: con.Name
                }));
                setMobileCarrires(transFormedCarriersList)

                // Second Crad types  
                const cardTypes = responseJson.Response.SecondCardTypes;
                const transFromedCardTypes = cardTypes.map(con => ({
                    Type: con.ParameterCode,
                    Name: con.DisplayText
                }))
                dispatch({ type: 'META_DATA_CARD_TYPES', payload: { SecondCardTypes: transFromedCardTypes } });

                //Primary Address 
                const primaryAddress = responseJson.Response.PrimaryCardAddress;
                const formattedAddress = `${primaryAddress.Line1} ${primaryAddress.Line2} ${primaryAddress.StateCode} ${primaryAddress.ZipCode}`
                dispatch({ type: 'SECONDARY_CARD_PRIMARY_ADDRESS', payload: { schPrimaryCardAddress: formattedAddress } });

            }
            setIsLoading(false)

        } catch (error) {

        }
    }

    const timezone = loggedResponse?.Profile?.Timezone;
    const matchedTimezone = metaDataResponse?.TimeZones?.find(
        tz => tz.DisplayText === timezone
    );
   
    const TimeZoneparameterCode = matchedTimezone?.ParameterCode;
    const shippingTypeId = metaDataResponse?.ShippingTypes?.[0]?.ShippingTypeID;

    // mobile validation or handle blur
    const handlePhoneBlurEvent = (e) => {
        const errorMessage = validateMobileNumberForSCH(phoneNumberSCH)

        if (errorMessage == 'Mobile number field is empty') {
            setShowMobielError(t('please_enter_phone_number'))
        } else if (errorMessage == 'Invalid mobile number') {
            setShowMobielError(t('please_enter_valid_phone_number'))
        }

    }

    const handleEmailBlurEvent = (e) => {
        const errorMessage = isEmailValid(schEmail)
        if (errorMessage == 'empty') {
            setEmailErrorMessage(t('please_enter_your_email_address'))
        } else if (errorMessage == 'not valid') {
            setEmailErrorMessage(t('please_enter_a_valid_email_address'))
        } else if (errorMessage == 'valid') {
            setEmailErrorMessage('')
        }

    }

    const handleStepThreeNextClicked = () => {
        generate2FA('phone')
    }

    const handleStepFourNextClicked = () => {
        generate2FA('email')
    }

    const handleStepFiveNextClicked = () => {
        setSteps(6)
    }

    const handleStepFourBackClikced = () => {
        setSteps(3)
    }

    const handleStepFiveBackClikced = () => {
        setSteps(4)
    }


    const handleStpeSixNextClicked = () => {
        setSelectedFirstNameInfo(firstName)
        setSelectedLastNameInfo(lastName)
        setSelectedDOBInfo(dob)
        setSelectedSSNInfo(ssnFromRedux)
        setSelectedPohoneNumberInfo(phoneNumberSCH)
        setSelectedEmailAdressInfo(schEmail)
        setSelectedAddressInfo(schPrimaryAddressText)
        setSteps(7)
    }

    const handleStepSixBackClicked = () => {
        setSteps(5)
    }



    const handleCustomerCareClick = () => {
        navigate('/Help/smiONE/ContactUs');
    }

    const onBackClickedsevenClicked = () =>{
        setSteps(6)
    }


    useEffect(() => {
        setSteps(1)
        // Clear all secondary card fields when component loads
        dispatch({ type: 'SECONDARY_CARD_FIRST_NAME', payload: { secondaryCardFirstName: '' } });
        dispatch({ type: 'SECONDARY_CARD_LAST_NAME', payload: { secondaryCardLastName: '' } });
        dispatch({ type: 'SECONDARY_CARD_DOB', payload: { secondaryCardDob: null } });
        dispatch({ type: 'SECONDARY_CARD_SSN', payload: { secondaryCardSsn: '' } });
        dispatch({ type: 'SECONDARY_CARD_CARRIERS', payload: { secondaryCardCarriers: '' } });
        dispatch({ type: 'SECONDARY_CARD_PHONENUMBER', payload: { secondaryCardPhoneNumber: '' } });
        dispatch({ type: 'SECONDARY_CARD_EMAIL_SCH', payload: { secondaryCardEmail: '' } });
        dispatch({ type: 'SECONDARY_CARD_CRADTYPES', payload: { secondaryCardCardTypes: '' } });

        getMetaDataResponse()
    }, []);

    useEffect(() => {
        if (ssnFromRedux) {
            const display = showSSN ? formatSSNValue(ssnFromRedux) : formatSecuredSSNValue(ssnFromRedux);
            setSSN(display);
            setSSNBackup(ssnFromRedux);
        }
    }, [ssnFromRedux, showSSN]);


    // generte otp for mobile
    const [isOpenGenerateMobileOtp, setIsOpenGenerateMobileOtp] = useState(false)
    const [isOpenGenerateEmailOtp, setIsOpenGenerateEmailOtp] = useState(false)


    const generate2FA = async (type) => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        var object = {
            "ActionType": "SecondaryCardRequest",
            "SecondaryCardRequest": {
                "Mobile1": phoneNumberSCH,
                "FirstName": firstName,
                "LastName": lastName,
                "DateOfBirth": dob,
                "ID1Type": "SSN",
                "ID1Value": ssnFromRedux
            }
        }

        var emailObj = {
            "ActionType": "SecondaryCardRequest",
            "SecondaryCardRequest": {
                "EmailID": schEmail,
                "ID": addOnCardRequestId
            }
        }

        const payload = type === "email" ? emailObj : object;

        const url = GENERATE_OTP_SCH(selectedItem?.CardKey);
        setIsLoading(true);
        try {
            const response = await PostRequest(url, payload, headers);
            setIsLoading(false);
            const parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode === STATUS_SUCCESS_CODE) {
                const loginSessionPayLoad = { loggedSessionKey: parsedResponse.Response.SessionKey };
                dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });
                if(type == 'phone'){
                const addOnCardRequestId = parsedResponse.Response.AddOnCardRequestId
                dispatch({ type: 'SECONDARY_ADD_ON_CARD_ID', payload: { schAddOnCardId: addOnCardRequestId } });
                setIsOpenGenerateMobileOtp(true)
                }else{
                 setIsOpenGenerateEmailOtp(true)
                }
                
            } else {
                var arrMessages = parsedResponse.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setShowGenerateOTPErrorMessage(displayText)
                setErrorModalForGenrateOTP(true)
                setIsLoading(false)
                
            }
        } catch (err) {

        }
    }

    const closeOTPVerifyModal = () => {
        setIsOpenGenerateMobileOtp(false)
    }

    const closeOtpEmailVerifyModal = () => {
        setIsOpenGenerateEmailOtp(false)
    }

    const verificationFaiure = (type, message) => {
        setShowMobielError(message);
    }

    const verificationSuccess = (type) => {
        setIsOpenGenerateMobileOtp(false)
        setSteps(4)
    }

    const verificationEmailFailure=(type, message)=>{
        setEmailErrorMessage(message)
    }
    const verficationEmailSuccess =(type)=>{
        setIsOpenGenerateEmailOtp(false)
        setSteps(5)
    }


    //info screen starst here 
   // info screen same section start here
    const [editNameClicked, setEditNameClicked] = useState(false);
    const [firstNameInfoError, setfirstNameInfoError] = useState('');
    const [lastNameInfoError, setlastNameInfoError] = useState('');
    const [selectedFirstNameInfo, setSelectedFirstNameInfo] = useState(firstName)
    const [selectedLastNameInfo, setSelectedLastNameInfo] = useState(lastName)

     const handleOnBlurFirstNameInfo = (e) => {
        if (!selectedFirstNameInfo || selectedFirstNameInfo.trim().length === 0) setfirstNameInfoError('Please enter first name');
        else setfirstNameInfoError('')
    }

    const handleLastNameBlurInfo = () => {
        if (!selectedLastNameInfo || selectedLastNameInfo.trim().length === 0) setlastNameInfoError('Please enter last name');
        else setlastNameInfoError('')
    }

    const editNameButtonClicked = async () => {
        setEditNameClicked(true);
        setEditSSNCkecked(false)
    }

    const updateNameButtonClicked = async () => {
        if (selectedFirstNameInfo.trim() == "") {
            setfirstNameInfoError(t('SCH_FIRST_NAME_REQUIRED'))
            return;
        }
        if (selectedLastNameInfo.trim() == "") {
            setlastNameInfoError(t('enter_lasttName'))
            return;
        }

        dispatch({ type: 'SECONDARY_CARD_FIRST_NAME', payload: { secondaryCardFirstName: selectedFirstNameInfo } });
        dispatch({ type: 'SECONDARY_CARD_LAST_NAME', payload: { secondaryCardLastName: selectedLastNameInfo } });
        setEditNameClicked(false);
    }

    // info screen name section end here 
     

            

    // info screen DOB starts here
    const [editDobClicked, setEditDobClicked] = useState(false);
    const [selectedDOBInfo, setSelectedDOBInfo] = useState(dob);
    const [DOBErrorInfo, setDOBErrorInfo] = useState('');

    const editDobButtonClicked = async () => {
        setEditDobClicked(true);
        setEditNameClicked(false);
        setEditSSNCkecked(false)
         setSelectedDOBInfo(dob)
    }

    const handleDateChangeInfo = (date) => {
        setDOBErrorInfo('');
        if (!date) {
            setDOBErrorInfo('Please select a valid date');
            return;
        }
        const today = new Date();
        const eighteenYearsAgo = new Date();
        eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 13);
        if (date > eighteenYearsAgo) {
            // Date of birth is less than 13 years ago
            setDOBErrorInfo('Date of birth should be greater than 13 years ago');
            return;
        }
        if (date > today) {
            // Date of birth is in the future
            setDOBErrorInfo('Date of birth cannot be in the future');
            return;
        }
      
        setDOBErrorInfo('');
        const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        setSelectedDOBInfo(utcDate);
    }

    const updateDobButtonInfoClicked = async () => {
        if (!selectedDOBInfo) {
            setSelectedDOBInfo('Date of birth is required');
            return;
        }

        const dateOfBirt = formatDateYYYYMMDDFORSCH(selectedDOBInfo);
        //setPersonalInfoObject(personalObject);
        // setDobChanged(true);
        dispatch({ type: 'SECONDARY_CARD_DOB', payload: { secondaryCardDob: dateOfBirt } });
        setEditDobClicked(false);
        setSelectedDOBInfo('');
    }
    // info screen DOB ends here

    // info SSN starts here
    const InputStylesInfo = "font-hanken-grotesk px-4 lg:text-[16px] md:text-[15px] text-[14px] placeholder:font-semibold font-medium focus:outline-none w-full h-[60px]";
    const [editSSNCkecked, setEditSSNCkecked] = useState(false);
    const [selectedSSNInfo, setSelectedSSNInfo] = useState(ssnFromRedux)
    const [ssnErrorInfo, setSsnErrorInfo] = useState("")
    const [showSSNInfo, setShowSSNInfo] = useState(false)
    const [isCursorVisibleInfo, setCursorVisibilityInfo] = useState(false)
    const toggleCursorInfo = () => setCursorVisibilityInfo(!isCursorVisibleInfo)
    const [ssnBackupInfo, setSSNBackupInfo] = useState("")
    const [ssnInfo, setSSNInfo] = useState("")
    const [showErrorMsgInfo, setShowErrorMessageInfo] = useState("");
    const [ssnSuccessModalInfo, setSsnSuccessModalInfo] = useState("");

    const maskedSSN =(ssnNum) =>{
      const last4 = ssnNum.slice(-4);
      return  `***_**_${last4}` 
    }

     const HeadingStylesInfo =
        "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--oops-edit-clr)]";
    const SubHeadingStylesInf =
        "font-serif-pro modal-title lg:text-[33px] md:text-[33px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-edit-spendsense)] md:w-[80%]";

    const formatSSNValueInfo = (value) => {
        const formattedValue = value
            .replace(/\D/g, '')
            .replace(/(\d{3})(\d{2})(\d{1,2})/, '$1 - $2 - $3');
        return formattedValue;
    }

    const formatSecuredSSNValueInfo = (value) => {
        const securedValue = value
            .replace(/[^0-9•]/g, '')
            .replace(/((?:\d|.){3})((?:\d|.){2})((?:\d|.){1,2})/, '$1 - $2 - $3')
            .replace(/[0-9]/g, '•');
        return securedValue;
    }

    const toggleShowSSNInfo = () => {
        const next = !showSSNInfo;
        const display = next ? formatSSNValueInfo(ssnBackupInfo) : formatSecuredSSNValueInfo(ssnBackupInfo);
        setShowSSNInfo(next);
        setSSNInfo(display);
    }

    const handleSSNChangeInfo = (event) => {
        const raw = event.target.value.replace(/[*-]/g, '').replace(/\D/g, '');
        if (raw.length <= 9) {
            setSSNBackupInfo(raw);
            const display = showSSNInfo ? formatSSNValueInfo(raw) : formatSecuredSSNValueInfo(raw);
            setSSNInfo(display);
            setSsnErrorInfo('');
            setSelectedSSNInfo(raw)
        }
    }


    const handleSsnErrorCloseModalInfo = () => {
        setSsnSuccessModalInfo(false)
    }

    const handleSSNBlurInfo = () => {
        if (!selectedSSNInfo || selectedSSNInfo.length !== 9) {
            setSsnErrorInfo('The SSN cannot be modified once submitted at the end of sign up.');
        } else {
            setSsnErrorInfo('');
        }
    }

    const editSSNButtonClickedInfo = async () => {
        setEditSSNCkecked(true)
        setEditDobClicked(false);
        setEditNameClicked(false);
    }

    const updateSSNButtonClickedInfo = async () => {
        if (!selectedSSNInfo || selectedSSNInfo.length !== 9) {
            setSsnErrorInfo(t('The SSN cannot be modified once submitted at the end of sign up.'))
            // setinfoMessage(t('enter_firstName'))
            return;
        }
        setIsLoading(true)
        const ssnBodyData = {
            "ssn": selectedSSNInfo
        }
        const deviceId = await retrieveData("updatedDeviceId");
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = VALIDATE_SECONDARY_CARD_SSN(selectedItem.CardKey)
        try {
            const response = await PostRequest(url, ssnBodyData, headers);
            const responseJson = JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {

                dispatch({ type: 'SECONDARY_CARD_SSN', payload: { secondaryCardSsn: selectedSSNInfo } });
                setEditSSNCkecked(false);
                setSsnSuccessModal(true)
                  setIsLoading(false)
            } else {
                var arrMessages = responseJson.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setShowErrorMessage(displayText)
                setIsLoading(false)
                setApisErrorModal(true)
               // setEditSSNCkecked(false);
                // dispatch({ type: 'SECONDARY_CARD_SSN', payload: { secondaryCardSsn: selectedSSNInfo } });
            }
        } catch (error) {
          
            // setEditSSNCkecked(false);
           // dispatch({ type: 'SECONDARY_CARD_SSN', payload: { secondaryCardSsn: selectedSSNInfo } });
        }
    }

    // info SSN end here

    // info Phone number here

    const [isOpenInfoGenerateMobileOTPModal , setIsOpenGenerateMobileOTPModal] = useState(false)
     const [isOpenInfoGenerateEmailOTPModal , setIsOpenGenerateEmailOTPModal] = useState(false)

      const generate2FAInfo = async (type) => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        var object = {
            "ActionType": "SecondaryCardRequest",
            "SecondaryCardRequest": {
                "Mobile1": selectedPohoneNumberInfo,
                "ID": addOnCardRequestId
            }
        }

        var emailObj = {
            "ActionType": "SecondaryCardRequest",
            "SecondaryCardRequest": {
                "EmailID": selectedEmailAdressInfo,
                "ID": addOnCardRequestId
            }
        }

        const payload = type === "email" ? emailObj : object;

        const url = GENERATE_OTP_SCH(selectedItem?.CardKey);
        setIsLoading(true);
        try {
            const response = await PostRequest(url, payload, headers);
            setIsLoading(false);
            const parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode === STATUS_SUCCESS_CODE) {
                const loginSessionPayLoad = { loggedSessionKey: parsedResponse.Response.SessionKey };
                dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });
                if(type == 'phone'){
              //  const addOnCardRequestId = parsedResponse.Response.AddOnCardRequestId
               // dispatch({ type: 'SECONDARY_ADD_ON_CARD_ID', payload: { schAddOnCardId: addOnCardRequestId } });
                setIsOpenGenerateMobileOTPModal(true)
                }else{
                 setIsOpenGenerateEmailOTPModal(true)
                }
                
            } else {
                var arrMessages = parsedResponse.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                if(type === "phone"){
                 setPhoneNumberErrorMsgInfo(displayText)
                }else{
                 setEmailErrorMsgInfo(displayText)
                }
                
                setIsLoading(false)
            }
        } catch (err) {

        }
    }

     const closeOTPVerifyInfoModal = () => {
        setSelectedPohoneNumberInfo(phoneNumberSCH)
        setPhoneNumberEditClickedInfo(false)
        setIsOpenGenerateMobileOTPModal(false)
    }

    const closeOtpEmailVerifyInfoModal = () => {
        setSelectedEmailAdressInfo(schEmail)
        setEmailAdressEditClickedInfo(false)
        setIsOpenGenerateEmailOTPModal(false)
    }

    const verificationFaiureInfo = (type, message) => {
        setPhoneNumberErrorMsgInfo(message);
    }

    const verificationSuccessInfo = (type) => {
        setPhoneNumberEditClickedInfo(false)
        dispatch({ type: 'SECONDARY_CARD_PHONENUMBER', payload: { secondaryCardPhoneNumber: selectedPohoneNumberInfo } })
        setIsOpenGenerateMobileOTPModal(false)
        
       
    }

    const verificationEmailFailureInfo=(type, message)=>{
        setEmailErrorMsgInfo(message)
    }
    const verficationEmailSuccessInfo =(type)=>{
        dispatch({ type: 'SECONDARY_CARD_EMAIL_SCH', payload: { secondaryCardEmail: selectedEmailAdressInfo } });
        setEmailAdressEditClickedInfo(false)
        setIsOpenGenerateEmailOTPModal(false)
        
       
    }

    const [phoneNumberEditClickedInfo, setPhoneNumberEditClickedInfo] = useState(false);
    const [formatedPhoneNumberInfo, setFormatedPhoneNumberInfo] = useState(phoneNumberSCH);
    const [phoneNumberErrorMsgInfo, setPhoneNumberErrorMsgInfo] = useState("")
    const [selectedPohoneNumberInfo, setSelectedPohoneNumberInfo] = useState(phoneNumberSCH);

    const handlePhoneBlurEventInfo = (e) => {
        const errorMessage = validateMobileNumberForSCH(selectedPohoneNumberInfo)
        // alert(errorMessage);
        if (errorMessage == 'Mobile number field is empty') {
            setPhoneNumberErrorMsgInfo(t('please_enter_phone_number'))
        } else if (errorMessage == 'Invalid mobile number') {
            setPhoneNumberErrorMsgInfo(t('please_enter_valid_phone_number'))
        }
        // else {
        //     generate2FAOtp(t('new_mobile'), '');
        // }
    }

    const editPhoneNumberClickedInfo = async () => {
        setPhoneNumberEditClickedInfo(true)
        setSelectedPohoneNumberInfo(phoneNumberSCH)
        setEditDobClicked(false)
        setEditNameClicked(false)
        setEditSSNCkecked(false)
    }


    const updatePhoneNumberInfo = async () => {
        const errorMessage = validateMobileNumberForSCH(selectedPohoneNumberInfo)
        // alert(errorMessage);
        if (errorMessage == 'Mobile number field is empty') {
            setPhoneNumberErrorMsgInfo(t('please_enter_phone_number'))
        } else if (errorMessage == 'not valid') {
            setPhoneNumberErrorMsgInfo(t('please_enter_valid_phone_number'))
        } else {
           generate2FAInfo("phone")
            // setPhoneNumberEditClickedInfo(false)
            // dispatch({ type: 'SECONDARY_CARD_PHONENUMBER', payload: { secondaryCardPhoneNumber: selectedPohoneNumberInfo } })
        }

    }
    // info Phone number ends here

    //info Email start here
    
    const [emailAdressEditClickedInfo, setEmailAdressEditClickedInfo] = useState(false);
    const [selectedEmailAdressInfo, setSelectedEmailAdressInfo] = useState(schEmail);
    const [emailErrorMsgInfo, setEmailErrorMsgInfo] = useState('')
    const editEmailClickedInfo = async () => {
        setEmailAdressEditClickedInfo(true)
        setPhoneNumberEditClickedInfo(false)
        setSelectedEmailAdressInfo(schEmail)
    }


    const handleEmailBlurEventInfo = (e) => {
        const errorMessage = isEmailValid(selectedEmailAdressInfo)
        if (errorMessage == 'empty') {
            setEmailErrorMsgInfo(t('please_enter_your_email_address'))

        } else if (errorMessage == 'not valid') {
            setEmailErrorMsgInfo(t('please_enter_a_valid_email_address'))

        } else if (errorMessage == 'valid') {
            setEmailErrorMsgInfo('')
        }
        // else {
        //     generate2FAOtp(t('new_email'));
        // }
    }

    const updateEmailAdressClickedInfo = async () => {
        const errorMessage = isEmailValid(selectedEmailAdressInfo)
        if (errorMessage == 'empty') {
            setEmailErrorMsgInfo(t('please_enter_your_email_address'))
        } else if (errorMessage == 'not valid') {
            setEmailErrorMsgInfo(t('please_enter_a_valid_email_address'))
        } else {
            generate2FAInfo("email")
            
            // setEmailAdressEditClickedInfo(false)
        }

    }

    //info Email end here

    //info Account Type starts here 

    const MetadatCardTypesInfo = useSelector(x => x.SecondCardTypes)
    const schSelectedCardTypeInfo = useSelector(x => x.secondaryCardCardTypes)

    //info Account Type ends here

    //Info Address section starts here

    // Address Section
    const [addressEditClickedInfo, setAddressEditClickedInfo] = useState(false)
    const [addressErrorMsgInfo, setAddressErrorMsgInfo] = useState('')
    const [selectedAddressInfo, setSelectedAddressInfo] = useState(schPrimaryAddressText)

    const editAddressButtonClickedInfo = async () => {
        setEditNameClicked(false);
        setEditDobClicked(false)
        setEditSSNCkecked(false)
        setAddressEditClickedInfo(true);
    }

    const handleOnBlurAddressInfo = (e) => {
        if (!selectedAddressInfo || selectedAddressInfo.trim().length === 0) setAddressErrorMsgInfo('Please enter address.');
        else setAddressErrorMsgInfo('')
    }

    const updateAddressButtonClickedInfo = async () => {
        if (selectedAddressInfo.trim() == "") {
            setAddressErrorMsgInfo(t('SCH_ADDRESS_REQUIRED'))
            // setinfoMessage(t('enter_firstName'))
            return;
        }
        dispatch({ type: 'SECONDARY_CARD_PRIMARY_ADDRESS', payload: { schPrimaryCardAddress: selectedAddressInfo } });
        setAddressEditClickedInfo(false);
    }

    const [showSCHSuccessModal , setShowSCHSuccessModal] = useState(false)
    const [showFinalAPIErrorModal , setShowFinalAPIErrorModal] =useState(false)
    const [showFinalAPIErrorMessage, setShowFinalAPIErrorMessage] = useState('')

    const finalAPIHit = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        var object = {
            "ID": String(addOnCardRequestId),
            "AccountType": schSelectedCardType.Type,
            "FirstName": firstName,
            "MiddleName": "",
            "LastName": lastName,
            "ID1Type": "SSN",
            "DateOfBirth": dob,
            "ID1Value": ssnFromRedux,
            "HomePhone": "",
            "EmailID": schEmail,
            "Mobile1": phoneNumberSCH,
            "Mobile1CarrierID": carriersForSCH.Type,
            "Timezone": TimeZoneparameterCode,
            "ShippingTypeID": shippingTypeId
        }

        const url = CREATE_SCH_CARD(selectedItem?.CardKey);
        setIsLoading(true);
        try {
            const response = await PostRequest(url, object, headers);
            setIsLoading(false);
            const parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode === STATUS_SUCCESS_CODE) {
                callPostLoginAPI()
                setShowSCHSuccessModal(true)
            } else {
                var arrMessages = parsedResponse.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                setShowFinalAPIErrorMessage(displayText)
                setShowFinalAPIErrorModal(true)
                setIsLoading(false)
                
            }
        } catch (err) {

        }
    }

    //info Address Section Ends here


    //Update post- login response
    async function callPostLoginAPI(isTrusted) {
        setIsLoading(true);
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const response = await GetRequest(GET_CARDHOLDER_CARDS, headers)
        setTimeout(() => {
            setIsLoading(false);
        }, 500);
        var responseObj = JSON.parse(response)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            if (responseObj.Response != undefined && responseObj.Response != null && responseObj.Response.length > 0) {
                const userCardsPayload = { userCards: JSON.stringify(responseObj.Response) };
                dispatch({ type: 'UPDATE_USER_CARDS', payload: userCardsPayload });
                dispatch({ type: 'SELECTED_USER_CARD_DETAILS', payload: { selectedCardDetails: responseObj.Response[0] } });
            }
        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
        }
    }

    const isNextDisabled = !firstName || firstName.trim().length === 0 || !lastName || lastName.trim().length === 0 || !dob || !ssnFromRedux || ssnFromRedux.length !== 9;
    const isNextDisabledStepThree = validateMobileNumberForSCH(phoneNumberSCH) !== 'Valid mobile number' || !(carriersForSCH && carriersForSCH?.Type && carriersForSCH?.Type.trim().length > 0);
    const isNextDisableforStepFor = isEmailValid(schEmail) !== 'valid';
    const isNextDisableForStepFive = !schSelectedCardType && schSelectedCardType?.Type && schSelectedCardType?.Type.trim().length > 0;
    const isNextDisableForStepSix = !schPrimaryAddressText || schPrimaryAddressText.trim().length === 0;
    const isFinalStepClick =
        editNameClicked ||
        editDobClicked ||
        editSSNCkecked ||
        phoneNumberEditClickedInfo ||
        emailAdressEditClickedInfo ||
        addressEditClickedInfo;

    return (
        <>
            <HomeLayout>
                {steps === 1 ? (<HomeHeader heading="" isHeaderCaption={false} selectedIndex={1} />) : (<HomeHeader heading={t('Add_Secondary_card_Side_heading')} isHeaderCaption={true} />)}
                <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight  '>
                    <DynamicCard
                        header={false}
                        footer={true}
                        CardRadius={true}
                        HeaderRadius={true}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        cardWidth={width.homeCard}
                        cardHeight={height.depositMoney}
                        backgroundColor={'--cardHeading-bg'}
                        HeaderContent={
                            <>
                                <CardHeading heading={ filteredCards.length > 0 ? t("MANAGE_SCH_CARD") : t("Add_secondary_card")} />
                            </>
                        }
                    >
                        {steps === 1 &&
                            (
                                <>
                                    <div className={`flex justify-center sm:mx-0 mx-4 ${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}`}>
                                        <div className='md:w-[85%] sm:w-[87%] w-full md:pt-16 pt-10 mb-20'>
                                        {filteredCards?.length > 0 &&
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2 mb-8
                                         ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Secondary cardholder name")}</p>
                                        }
                                        {filteredCards?.map((item, index) => (
                                            <>
                                                <div className="flex justify-between items-center w-full">
                                                    <p className={`font-hanken-grotesk   lg:text-[16px] md:text-[16px]
                                        sm:text-[11px] text-[13px] font-[700] tracking-[2px] pb-2 mb-6
                               ${kudzuPlusTrue ? 'text-white' : ''}`}>{item.NameOnCard}</p><img className='' src={Check} alt="Selected" />
                                                </div>
                                                <div className="bg-[var(--personal-info-border)] opacity-50 h-0.5 min-h- w-full mb-7"></div>
                                            </>
                                        ))}
                                            <p className={`font-hanken-grotesk ${kudzuPlusTrue ? 'text-white' : ''} mb-20 text-[var(--primary-text-cards)]  
                                       lg:text-[20px] md:text-[12px] sm:text-[9px] text-[13px]
                                        font-[500] tracking-[1px] md:pb-8 pb-4 `}>{addLineBreaks(t("Add_secondary_card_main_text"))}</p>
                                        <button type="button" onClick={handleStepOneClicked} disabled={filteredCards.length >= 5} className={`font-hanken-grotesk lg:text-[18px] md:text-[17px]
                                   sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-white  border-2 px-2 py-4 border-[#2965FB] w-full ${filteredCards.length >= 5 ? 'bg-[#94C3E8] border-[#94C3E8] cursor-not-allowed' : "bg-[#2965FB] border-[#2965FB] cursor-pointer"}`}
                                            >{t("Add_secondary_card")}</button>
                                        </div>
                                    </div>
                                </>
                            )}

                        {steps === 2 && (
                            <>
                                <div className={`flex flex-col sm:mx-0 mx-4 ${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}`}>
                                    <div className='w-full mx-auto'>
                                        <p className='text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                        sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                        text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4'>{t('Lets_Get_Started_Step_Two')}</p>
                                        <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{addLineBreaks(t('Basic_Information_Step_Two'))}</p>
                                    </div>
                                    <div className='flex justify-center'>
                                        <div className='md:w-[75%] sm:w-[87%] w-full md:pt-6 pt-10 '>
                                            <CustomTextInput
                                                onKeyDown={(event) => {
                                                    if (event.key == "Enter") {
                                                        event.preventDefault(); event.target.style.opacity = 0.8;
                                                        setTimeout(() => { event.target.style.opacity = 1; }, 200);
                                                    }
                                                }}
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (inputValue.length <= 50) {
                                                        dispatch({ type: 'SECONDARY_CARD_FIRST_NAME', payload: { secondaryCardFirstName: inputValue } });
                                                    } else {
                                                        console.log('Input length exceeds 50 characters');
                                                    }
                                                }}
                                                onBlur={(event) => handleOnBlur(event)}
                                                value={firstName ? `${firstName}` : ''}
                                                error={firstNameError}
                                                placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                            />
                                            <div className='mb-20 mt-14'>
                                                <CustomTextInput
                                                    onKeyDown={(event) => {
                                                        if (event.key == "Enter") {
                                                            event.preventDefault(); event.target.style.opacity = 0.8;
                                                            setTimeout(() => { event.target.style.opacity = 1; }, 200);
                                                        }
                                                    }}
                                                    onChange={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (inputValue.length <= 50) {
                                                            dispatch({ type: 'SECONDARY_CARD_LAST_NAME', payload: { secondaryCardLastName: inputValue } });
                                                        }
                                                    }}
                                                    onBlur={handleLastNameBlur}
                                                    value={lastName}
                                                    error={lastNameError}
                                                    placeholder={"Last name"}
                                                    inputWidth={`w-full`}
                                                />
                                            </div>
                                            <div className='mb-20'>
                                                <DatePicker
                                                    selected={dob}
                                                    onChange={(date) => {
                                                        const today = new Date();
                                                        const thirteenYearsAgo = new Date();
                                                        thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear() - 13);
                                                        if (date > thirteenYearsAgo) {
                                                            setDobError('Date of birth should be greater than 13 years ago');
                                                            return;
                                                        }
                                                        if (date > today) {
                                                            setDobError('Date of birth cannot be in the future');
                                                            return;
                                                        }
                                                        setDobError('');
                                                        dispatch({ type: 'SECONDARY_CARD_DOB', payload: { secondaryCardDob: date } });
                                                    }}
                                                    dateFormat="MMMM d, yyyy"
                                                    className='font-hanken-grotesk px-4 py-2 text-[var(--input-text)] bg-[var(--input-bg)] placeholder-[var(--input-text)] text-sm font-medium focus:outline-none w-full h-[60px] placeholder:font-semibold'
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    placeholderText={t("date_of_birth_placeholder")}
                                                    autoComplete='off'
                                                    yearDropdownItemNumber={100}
                                                    scrollableYearDropdown
                                                    maxDate={new Date()}
                                                    openToDate={(() => {
                                                        const thirteenYearsAgo = new Date();
                                                        thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear() - 13);
                                                        return thirteenYearsAgo;
                                                    })()}
                                                />

                                                <div className='mb-4 mt-4'>
                                                    {dobError && (
                                                        displayErrorMessage(dobError)
                                                    )}
                                                </div>
                                            </div>
                                            <div className=''>
                                                <div
                                                    onFocus={toggleCursor}
                                                    onBlur={toggleCursor}
                                                    className='relative'
                                                >
                                                    <div className="flex items-center relative">
                                                        <button
                                                            type="button"
                                                            className="text-gray-500 absolute right-4 top-5 bg-transparent border-0 p-0 cursor-pointer"
                                                            onClick={toggleShowSSN}
                                                            aria-label={showSSN ? t('hide_ssn_alt') : t('show_ssn_alt')}
                                                        >
                                                            {showSSN ? <img src={appThemeData.Showpassword} className='w-[20px] h-[20px]' alt="" aria-hidden="true" /> : <img src={HideSSNPic} className='w-[20px] h-[20px]' alt="" aria-hidden="true" />}
                                                        </button>
                                                        <input
                                                            id={'ssn_no'}
                                                            value={ssnFromRedux || ''}
                                                            placeholder={'SSN'}
                                                            className={`${InputStyles} ${!kudzuPlusTrue ? 'border-2 border-[#DCDCD6]' : ''} focus:border-2 focus:border-[#4076FF] bg-[var(--input-bg)] text-[var(--input-text)] placeholder-[var(--input-text1)] ${showSSN ? 'password-input' : ''}`}
                                                            autoComplete="off"
                                                            onChange={handleSSNChange}
                                                            onBlur={handleSSNBlur}
                                                            maxLength={9}
                                                            style={{ color: 'transparent', caretColor: 'transparent' }}
                                                        />
                                                    </div>
                                                    <div className='flex z-[999] opacity-100 relative top-[-51px] h-[60px] w-[80%] bg-transparent items-center'
                                                        style={{ position: 'relative', top: -48 }}
                                                        onClick={() => {
                                                            const input = document.getElementById("ssn_no");
                                                            input.focus()
                                                        }}>
                                                        <p className='h-[50px] no-underline ml-[15px] top-[10] text-[var(--input-text1)]' >{ssnFromRedux ? (showSSN ? formatSSNValue(ssnFromRedux) : formatSecuredSSNValue(ssnFromRedux)) : ''}{isCursorVisible && <span style={{ display: 'inline-block', animation: isCursorVisible ? 'blink 0.8s step-end infinite' : 'none', verticalAlign: 'text-bottom', color: '#2965FB', fontWeight: '200', fontSize: '15px' }}>|</span>}</p>
                                                    </div>
                                                    <style>{`@keyframes blink {0%, 100% {opacity: 1;}50% {opacity: 0;}}`}</style>
                                                    <div className='mb-4 mt-4'>
                                                        {ssnError && (
                                                            displayErrorMessageSCHSSN(ssnError)
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex flex-row sm:justify-end justify-between mb-16'>
                                    <button
                                        type="button"
                                        onClick={handleSteptwoBackClick}
                                        className='font-hanken-grotesk text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] bg-transparent border-0 cursor-pointer'
                                    >
                                        {t("personal_back")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleStepTwoNextClick}
                                        disabled={isNextDisabled}
                                        className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 bg-transparent border-0 ${isNextDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                    >
                                        {t("Next")}
                                    </button>
                                </div>
                            </>
                        )}


                        {steps === 3 && (
                            <>
                                <div className={`flex flex-col sm:mx-0 mx-4 ${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}`}>
                                    <div className='w-full mx-auto'>
                                        <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] mt-8
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}><span className='text-[var(--text-clrs)]'>Next, </span></p>
                                        <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t('SHARED_CARD_SELECTION_TEXT_STEP_THREE'))}</p>
                                    </div>
                                    <div className='flex justify-center'>
                                        <div className='md:w-[75%] sm:w-[87%] w-full md:pt-6 pt-10 '>
                                            <CustomTextInput
                                                maxLength={10}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setShowMobielError('')
                                                    dispatch({ type: 'SECONDARY_CARD_PHONENUMBER', payload: { secondaryCardPhoneNumber: inputValue } });
                                                }}
                                                onBlur={(e) => handlePhoneBlurEvent(e)}
                                                value={phoneNumberSCH}
                                                error={showMobileError}
                                                //style={{ width: '100%', height: '51px' }}
                                                inputWidth={`w-full`}
                                                placeholder={"Phone number"}
                                               // type="number"
                                               disallowSpaces={true}
                                               numbersOnly={true}
                                            />
                                            <div className='mb-20 mt-14'>
                                                 <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Mobile Carrier")}</p>
                                                <CustomDropdown
                                                    options={mobileCarriers}
                                                    onSelect={(option) => {
                                                        // setSelectedMobileCarriers(option)
                                                        dispatch({ type: 'SECONDARY_CARD_CARRIERS', payload: { secondaryCardCarriers: option } });
                                                    }}
                                                    selectedAccountType={carriersForSCH}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex flex-row sm:justify-end justify-between mb-16'>
                                    <button
                                        type="button"
                                        onClick={handleStepThreeBackClick}
                                        className='font-hanken-grotesk text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] bg-transparent border-0 cursor-pointer'
                                    >
                                        {t("personal_back")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleStepThreeNextClicked}
                                        disabled={isNextDisabledStepThree}
                                        className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 bg-transparent border-0 ${isNextDisabledStepThree ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                    >
                                        {t("Next")}
                                    </button>
                                </div>
                            </>
                        )}

                        {steps === 4 && (
                            <>
                                <div className={`flex flex-col sm:mx-0 mx-4 ${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}`}>
                                    <div className='w-full mx-auto mb-4'>
                                        <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] mt-8
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}><span className='text-[var(--text-clrs)]'>Next, </span></p>
                                        <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t('Email_SCH_MAIN_TEXT'))}</p>
                                    </div>
                                    <div className='flex justify-center mb-24'>
                                        <div className='md:w-[75%] sm:w-[87%] w-full md:pt-6 pt-10 '>
                                            <CustomTextInput
                                                maxLength={35}
                                                autoFocus={true}
                                                placeholder={t("Email address")}
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setEmailErrorMessage('')
                                                    dispatch({ type: 'SECONDARY_CARD_EMAIL_SCH', payload: { secondaryCardEmail: inputValue } });
                                                }}
                                                onBlur={(e) => handleEmailBlurEvent(e)}
                                                value={schEmail}
                                                inputWidth={`w-full`}
                                                error={showEmailErrorMessage}
                                                disallowSpaces={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex flex-row sm:justify-end justify-between mb-16'>
                                    <button
                                        type="button"
                                        onClick={handleStepFourBackClikced}
                                        className='font-hanken-grotesk text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] bg-transparent border-0 cursor-pointer'
                                    >
                                        {t("personal_back")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleStepFourNextClicked}
                                        disabled={isNextDisableforStepFor}
                                        className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 bg-transparent border-0 ${isNextDisableforStepFor ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                    >
                                        {t("Next")}
                                    </button>
                                </div>
                            </>
                        )}


                        {steps === 5 && (
                            <>
                                <div className={`flex flex-col sm:mx-0 mx-4 ${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}`}>
                                    <div className='w-full mx-auto mb-10'>
                                        <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] mt-8
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}><span className='text-[var(--text-clrs)]'>Next, </span>{t('CARD_TYPE_MAIN_TEXT')}</p>

                                    </div>
                                    <div className='flex justify-center'>
                                        <div className='md:w-[75%] sm:w-[87%] w-full md:pt-6 pt-10 '>
                                              <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("account type")}</p>
                                            <CustomDropdown
                                                options={MetadatCardTypes}
                                                onSelect={(option) => {

                                                    dispatch({ type: 'SECONDARY_CARD_CRADTYPES', payload: { secondaryCardCardTypes: option } });
                                                }}
                                                selectedAccountType={schSelectedCardType}
                                            />
                                            <p className={`font-hanken-grotesk mb-20 text-[var(--primary-text-cards)]  
                                       lg:text-[18px] md:text-[12px] sm:text-[9px] text-[13px]
                                        font-[500] tracking-[1px] md:pb-8 pb-4 mt-10 ${kudzuPlusTrue ? "text-white" : ""}`}>{addLineBreaks(t("CARD_TYPE_FOOTER_TEXT"))}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex flex-row sm:justify-end justify-between mb-16'>
                                    <button
                                        type="button"
                                        onClick={handleStepFiveBackClikced}
                                        className='font-hanken-grotesk text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] bg-transparent border-0 cursor-pointer'
                                    >
                                        {t("personal_back")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleStepFiveNextClicked}
                                        disabled={isNextDisableForStepFive}
                                        className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 bg-transparent border-0 ${isNextDisableForStepFive ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                    >
                                        {t("Next")}
                                    </button>
                                </div>
                            </>
                        )}

                        {steps === 6 && (
                            <>
                                <div className={`flex flex-col sm:mx-0 mx-4 ${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}`}>
                                    <div className="w-full mx-auto mt-4">
                                        <p className={`text-start ${kudzuPlusTrue ? "text-white" : ""} sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 mb-6 `}><span className='text-[var(--text-clrs)]'>{t('SCH_GREAT')} </span>{(t('SCH_ADDRESS_HEADING'))}</p>
                                        <p
                                            className={`font-hanken-grotesk text-[var(--primary-text-cards)]
      lg:text-[16px] md:text-[12px] sm:text-[9px] text-[13px]
      font-[500] tracking-[0px]  whitespace-nowrap
      ${kudzuPlusTrue ? "text-white" : ""}`}
                                        >
                                            {t("SCH_ADDRESS_MAIN_TEXT_ONE")}
                                            <span className="font-[700]">{t("SCH_ADDRESS_DAYS")}</span>
                                        </p>
                                        <p
                                            className={`font-hanken-grotesk w-[77%] text-[var(--primary-text-cards)]
      lg:text-[16px] md:text-[12px] sm:text-[9px] text-[13px]
      font-[500] tracking-[0px] md:pb-8 pb-4
      ${kudzuPlusTrue ? "text-white" : ""}`}
                                        >
                                            {t("SCH_ADDRESS_MAIN_TEXT_TWO")}
                                            <Link to="/Help/smiONE/ContactUs" className="text-[var(--text-clrs)] cursor-pointer font-hanken-grotesk">{t("Customer Care")}</Link>{" "}
                                            <span>{t("SCH_ADDRESS_MAIN_TEXT_THREE")}</span>
                                        </p>
                                    </div>

                                    <div className='flex justify-center mb-24'>
                                        <div className='md:w-[75%] sm:w-[87%] w-full md:pt-0 pt-10 '>

                                            <CustomTextInput
                                                onKeyDown={(event) => {
                                                    if (event.key == "Enter") {
                                                        event.preventDefault(); event.target.style.opacity = 0.8;
                                                        setTimeout(() => { event.target.style.opacity = 1; }, 200);
                                                    }
                                                }}
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    dispatch({ type: 'SECONDARY_CARD_PRIMARY_ADDRESS', payload: { schPrimaryCardAddress: inputValue } });

                                                }}
                                                onBlur={handleAddressBlur}
                                                value={schPrimaryAddressText}
                                                error={addressError}
                                                placeholder={"Address"}
                                                inputWidth={`w-full`}
                                            />
                                            <p className={`font-hanken-grotesk mb-20 text-[var(--primary-text-cards)]  
                                       lg:text-[14px] md:text-[10px] sm:text-[9px] text-[13px]
                                        font-[500] tracking-[1px] md:pb-8 pb-4 mt-10 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t("SCH_ADDRESS_FOOTER_TEXT"))}<Link to="/Help/smiONE/ContactUs" className='text-[var(--text-clrs)] text-16 font-[700] font-hanken-grotesk'>{t('Customer Care.')}</Link></p>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex flex-row sm:justify-end justify-between mb-16'>
                                    <button
                                        type="button"
                                        onClick={handleStepSixBackClicked}
                                        className='font-hanken-grotesk text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] bg-transparent border-0 cursor-pointer'
                                    >
                                        {t("Cancel")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleStpeSixNextClicked}
                                        disabled={isNextDisableForStepSix}
                                        className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 bg-transparent border-0 ${isNextDisableForStepSix ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                    >
                                        {t("Review")}
                                    </button>
                                </div>
                            </>
                        )}

                        {steps === 7 && (
                            <>
                                <div className={`flex flex-col sm:mx-0 mx-4 ${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}`}>
                                    <div className='w-full mx-auto mt-4'>
                                        <p className={`font-hanken-grotesk text-[var(--primary-text-cards)]  
                                   lg:text-[16px] md:text-[12px] sm:text-[9px] text-[13px]
                                   font-[500] tracking-[0px] pb-4 mb-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{addLineBreaks(t("SCH_INFO_TEXT"))}</p>
                                    </div>
                                    <div className='flex justify-center mb-24'>
                                        <div className='md:w-[75%] sm:w-[87%] w-full md:pt-6 pt-4 '>
                                             {/* NAME SECTION */}
                                            {!editNameClicked &&
                                                <div className='mt-8'>
                                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("full_name")}</p>
                                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] mb-2 text-[var(--modal-text-heading-clr)]">
                                                        {firstName + " " + lastName}</p>
                                                    <div className="bg-[var(--personal-info-border)] opacity-50 h-0.5 min-h-1 w-full"></div>
                                                    <button
                                                        type="button"
                                                        onClick={() => { editNameButtonClicked() }}
                                                        className='pt-3 font-hanken-grotesk text-[var(--modal-text-highlight)] md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer text-left p-0'
                                                    >
                                                        {t("edit_name")}
                                                    </button>
                                                </div>
                                            }

                                            {/*  Name update section*/}
                                            {editNameClicked &&
                                                <div className='md:mt-16 mt-12'>
                                                    <div className='w-full'>
                                                        <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("First Name")}</p>
                                                        <CustomTextInput
                                                            maxLength={35}
                                                            autoFocus={true}
                                                            textColor={true}
                                                            onChange={(event) => {
                                                                //setinfoMessage('');
                                                                setfirstNameInfoError('')
                                                                setlastNameInfoError('')
                                                                setSelectedFirstNameInfo(event.target.value)
                                                            }}
                                                            onBlur={(e) => handleOnBlurFirstNameInfo(e)}
                                                            value={selectedFirstNameInfo} style={{ width: '100%', height: '51px' }}
                                                            error={firstNameInfoError}
                                                        />
                                                        <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Last Name")}</p>
                                                        <CustomTextInput
                                                            maxLength={35}
                                                            autoFocus={true}
                                                            onChange={(event) => {
                                                                setfirstNameInfoError('')
                                                                setlastNameInfoError('')
                                                                setSelectedLastNameInfo(event.target.value)
                                                            }}
                                                            onBlur={(e) => handleLastNameBlurInfo(e)}
                                                            error={lastNameInfoError}
                                                            value={selectedLastNameInfo} style={{ width: '100%', height: '51px' }} />
                                                    </div>

                                                    <button
                                                        type="button"
                                                        onClick={() => { updateNameButtonClicked() }}
                                                        className='font-hanken-grotesk text-[var(--modal-text-highlight)] md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer'
                                                    >
                                                        {t("save")}
                                                    </button>
                                                </div>
                                            }

                                            {/* Date of Birth section */}
                                            {!editDobClicked &&
                                                <div className='md:mt-10 mt-8'>
                                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px]
                                                         sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4
                                                ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("date_of_birth")}</p>
                                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                                     font-medium leading-[26px] md:mb-6 mb-2 text-[var(--modal-text-heading-clr)]">
                                                        {dob ? formatDateToDDMMYYYYFORSCH(dob) : ''}
                                                    </p>
                                                    <div className="bg-[var(--personal-info-border)] opacity-50 h-0.5 min-h-1 w-full"></div>

                                                    <button
                                                        type="button"
                                                        onClick={() => { editDobButtonClicked() }}
                                                        className='pt-5 font-hanken-grotesk text-[var(--modal-text-highlight)] md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer text-left p-0 pt-5'
                                                    >
                                                        {t("edit_date_of_birth")}
                                                    </button>
                                                </div>
                                            }

                                            {/* DOB EDIT SECTION */}
                                            {editDobClicked &&
                                                <div className='md:mt-16 mt-12'>
                                                    <div className='w-full'>
                                                        <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px]
                                                         sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4
                                                ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("date_of_birth")}</p>
                                                        <DatePicker
                                                            selected={selectedDOBInfo ? new Date(selectedDOBInfo) : null}
                                                            onChange={handleDateChangeInfo}
                                                            dateFormat="MM/dd/yyyy"
                                                           placeholderText={t("date_of_birth_placeholder")}
                                                            className="font-hanken-grotesk text-[var(--input-text)] px-4 bg-[var(--input-bg)] placeholder-[var(--input-text)] text-sm font-medium focus:outline-none w-full h-[60px]"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            yearDropdownItemNumber={150}
                                                            scrollableYearDropdown
                                                        />
                                                    </div>
                                                    {DOBErrorInfo && (
                                                        displayErrorMessage(DOBErrorInfo)
                                                    )}
                                                    <button
                                                        type="button"
                                                        onClick={() => { updateDobButtonInfoClicked() }}
                                                        className='font-hanken-grotesk text-[var(--modal-text-highlight)] md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer'
                                                    >
                                                        {t("save")}
                                                    </button>
                                                </div>
                                            }


                                            {/* SSN SECTION */}
                                            {!editSSNCkecked &&
                                                <div className='md:mt-20 mt-12'>
                                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("SSN")}</p>
                                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] md:mb-6 mb-2 text-[var(--modal-text-heading-clr)]">
                                                        {maskedSSN(ssnFromRedux)}</p>
                                                    <div className="bg-[var(--personal-info-border)] opacity-50 h-0.5 min-h-1 w-full"></div>
                                                    <button
                                                        type="button"
                                                        onClick={() => { editSSNButtonClickedInfo() }}
                                                        className='pt-5 font-hanken-grotesk text-[var(--modal-text-highlight)] md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer text-left p-0 pt-5'
                                                    >
                                                        {t("SCH_EDIT_SSN")}
                                                    </button>
                                                </div>
                                            }

                                            {/* Edit SSN SECTION */}
                                            {
                                                editSSNCkecked &&
                                                <div className='md:mt-16 mt-12'>
                                                    <div className='w-full'>
                                                        <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("SSN")}</p>
                                                        <div
                                                            onFocus={toggleCursorInfo}
                                                            onBlur={toggleCursorInfo}
                                                            className='relative'
                                                        >
                                                            <div className="flex items-center relative">
                                                                <button
                                                                    type="button"
                                                                    className="text-gray-500 absolute right-4 top-5 bg-transparent border-0 p-0 cursor-pointer"
                                                                    onClick={toggleShowSSNInfo}
                                                                >
                                                                    {showSSNInfo ? 'Show' : 'Hide'}
                                                                </button>
                                                                <input
                                                                    id={'ssn_no'}
                                                                    value={selectedSSNInfo || ''}
                                                                    placeholder={'Social Security Number (SSN)'}
                                                                    className={`${InputStylesInfo} ${!kudzuPlusTrue ? 'border-2 border-[#DCDCD6]' : ''} focus:border-2 focus:border-[#4076FF] bg-[var(--input-bg)] text-[var(--input-text)] placeholder-[var(--input-text1)] ${showSSNInfo ? 'password-input' : ''}`}
                                                                    autoComplete="off"
                                                                    onChange={handleSSNChangeInfo}
                                                                    onBlur={handleSSNBlurInfo}
                                                                    maxLength={9}
                                                                    style={{ color: 'transparent', caretColor: 'transparent' }}
                                                                />
                                                            </div>
                                                            <div className='flex z-[999] opacity-100 relative top-[-51px] h-[60px] w-[80%] bg-transparent items-center'
                                                                style={{ position: 'relative', top: -48 }}
                                                                onClick={() => {
                                                                    const input = document.getElementById("ssn_no");
                                                                    input.focus()
                                                                }}>
                                                                <p className='h-[50px] no-underline ml-[15px] top-[10] text-[var(--input-text1)]' >{selectedSSNInfo ? (showSSNInfo ? formatSSNValueInfo(selectedSSNInfo) : formatSecuredSSNValueInfo(selectedSSNInfo)) : ''}{isCursorVisibleInfo && <span style={{ display: 'inline-block', animation: isCursorVisibleInfo ? 'blink 0.8s step-end infinite' : 'none', verticalAlign: 'text-bottom', color: '#2965FB', fontWeight: '200', fontSize: '15px' }}>|</span>}</p>
                                                            </div>
                                                            <style>{`@keyframes blink {0%, 100% {opacity: 1;}50% {opacity: 0;}}`}</style>
                                                            {ssnErrorInfo && (
                                                                displayErrorMessage(ssnErrorInfo)
                                                            )}


                                                            <button
                                                                type="button"
                                                                onClick={() => { updateSSNButtonClickedInfo() }}
                                                                className='font-hanken-grotesk text-[var(--modal-text-highlight)] mt-2 md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer'
                                                            >
                                                                {t("save")}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            }


                                            {/*  phoneNumber section */}
                                            {!phoneNumberEditClickedInfo &&
                                                <div className='md:mt-16 sm:mt-10 mt-12'>
                                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("phone_number")}</p>

                                                    <p className="font-hanken-grotesk text-[var(--text-clr-transactions)]  lg:text-[16px] md:text-[15px] sm:text-[13px] 
                                                            text-[14px] md:font-[500] sm:font-[700] font-[500] leading-[26px] md:mb-6 mb-2">

                                                        {phoneNumberSCH
                                                            ? personalFormatPhoneNumber(phoneNumberSCH.toString())
                                                            : ''}
                                                    </p>
                                                    <div className="bg-[var(--personal-info-border)] opacity-50 h-0.5 min-h-1 w-full"></div>

                                                    <button
                                                        type="button"
                                                        onClick={() => { editPhoneNumberClickedInfo() }}
                                                        className='pt-5 font-hanken-grotesk text-[var(--btn-clr-cards)] lg:text-[16px] md:text-[15px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer text-left p-0 pt-5'
                                                    >
                                                        {t("SCH_EDIT_MOBILE_LABALE")}
                                                    </button>
                                                </div>
                                            }

                                            {/*  phoneNumber update section */}
                                            {phoneNumberEditClickedInfo &&
                                                <div className='md:mt-16 sm:mt-10 mt-12'>
                                                    <div className='w-full'>
                                                        <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("phone_number")}</p>
                                                        <CustomTextInput
                                                            maxLength={10}
                                                            autoFocus={true}
                                                            onChange={(event) => {
                                                                setSelectedPohoneNumberInfo(event.target.value)
                                                                setPhoneNumberErrorMsgInfo('')
                                                            }}
                                                            onBlur={(e) => handlePhoneBlurEventInfo(e)}
                                                             disallowSpaces={true}
                                                             numbersOnly={true}
                                                            value={selectedPohoneNumberInfo} style={{ width: '100%', height: '51px' }}
                                                        />

                                                        {phoneNumberErrorMsgInfo &&
                                                            <div className='mb-2'>
                                                                {displayErrorMessage(phoneNumberErrorMsgInfo)}
                                                            </div>
                                                        }
                                                        <button
                                                            type="button"
                                                            onClick={() => { updatePhoneNumberInfo() }}
                                                            className='font-hanken-grotesk text-[var(--modal-text-highlight)] md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer'
                                                        >
                                                            {t("save")}
                                                        </button>
                                                    </div>
                                                </div>
                                            }

                                            
                                            
                                            {/* email address section */}
                                            {!emailAdressEditClickedInfo &&
                                                <div className='md:mt-16 sm:mt-10 mt-12'>
                                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("personal_email_address")}</p>

                                                    <p className="font-hanken-grotesk text-[var(--text-clr-transactions)] lg:text-[16px] md:text-[15px] sm:text-[13px] 
                                    text-[14px] md:font-[500] sm:font-[700] font-[500] leading-[26px] md:mb-6 mb-2">
                                                        {schEmail}</p>

                                                    <div className="bg-[var(--personal-info-border)] opacity-50 h-0.5 min-h-1 w-full"></div>

                                                    <button
                                                        type="button"
                                                        onClick={() => { editEmailClickedInfo() }}
                                                        className='pt-5 font-hanken-grotesk text-[var(--btn-clr-cards)] lg:text-[16px] md:text-[15px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer text-left p-0 pt-5'
                                                    >
                                                        {t("SCH_EDIT_EMAIL_ADDRESS")}
                                                    </button>
                                                </div>
                                            }

                                            {/* email address  update section */}
                                            {emailAdressEditClickedInfo &&
                                                <div className='md:mt-16 sm:mt-10 mt-12'>
                                                    <div className='w-full'>
                                                        <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("personal_email_address")}</p>
                                                        <CustomTextInput
                                                            maxLength={35}
                                                            autoFocus={true}
                                                            onChange={(event) => {
                                                                setSelectedEmailAdressInfo(event.target.value)
                                                                setEmailErrorMsgInfo('')
                                                            }}
                                                            onBlur={(e) => handleEmailBlurEventInfo(e)}
                                                            value={selectedEmailAdressInfo} style={{ width: '100%', height: '51px' }} disallowSpaces={true}/>
                                                    </div>

                                                    {emailErrorMsgInfo &&
                                                        <div className='mb-2'>
                                                            {kudzuPlusTrue ? displayKudzuplusErrorMessage(emailErrorMsgInfo) : displayErrorMessage(emailErrorMsgInfo)}
                                                        </div>
                                                    }
                                                    <button
                                                        type="button"
                                                        onClick={() => { updateEmailAdressClickedInfo() }}
                                                        className='font-hanken-grotesk text-[var(--modal-text-highlight)] md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer'
                                                    >
                                                        {t("save")}
                                                    </button>
                                                </div>
                                            }


                                            <div className='md:mt-16 sm:mt-10 mt-12'>
                                                <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("SCH_ACCOUNT_TYPE_LABEL")}</p>
                                                <div className='w-full'>
                                                    <CustomDropdown
                                                        options={MetadatCardTypes}
                                                        onSelect={(option) => {

                                                            dispatch({ type: 'SECONDARY_CARD_CRADTYPES', payload: { secondaryCardCardTypes: option } });
                                                        }}
                                                        selectedAccountType={schSelectedCardType}
                                                        name={t("personal_email_address")}
                                                    />
                                                    <div className="bg-[var(--personal-info-border)] opacity-50 h-0.3 min-h-0.5 w-full"></div>
                                                </div>
                                            </div>



                                            {/* address section */}
                                            {!addressEditClickedInfo &&
                                                <div className='md:mt-20 mt-12'>
                                                    <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Address")}</p>
                                                    <p className="font-hanken-grotesk md:text-[16px] sm:text-[14px] text-[14px]
                                    font-medium leading-[26px] md:mb-6 mb-2 text-[var(--modal-text-heading-clr)]">
                                                        {schPrimaryAddressText}</p>
                                                    <div className="bg-[var(--personal-info-border)] opacity-50 h-0.5 min-h-1 w-full"></div>
                                                    <button
                                                        type="button"
                                                        onClick={() => { editAddressButtonClickedInfo() }}
                                                        className='bg-transparent border-0 cursor-pointer'
                                                        aria-label={t("SCH_EDIT_ADDRESS")}
                                                        style={{display: 'none'}}
                                                    >
                                                        {/* {t("SCH_EDIT_ADDRESS")} */}
                                                    </button>
                                                </div>
                                            }

                                            {/*  Address update section*/}
                                            {addressEditClickedInfo &&
                                                <div className='md:mt-16 mt-12'>
                                                    <div className='w-full'>
                                                        <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase  lg:text-[13px] md:text-[13px] 
                                        sm:text-[11px] text-[13px] font-[600] tracking-[2px] md:pb-8 pb-4 
                               ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Address")}</p>
                                                        <CustomTextInput
                                                            autoFocus={true}
                                                            onChange={(event) => {
                                                                setAddressErrorMsgInfo('')
                                                                setSelectedAddressInfo(event.target.value)
                                                            }}
                                                            onBlur={(e) => handleOnBlurAddressInfo(e)}
                                                            value={selectedAddressInfo}
                                                            style={{ width: '100%', height: '51px' }}
                                                            error={addressErrorMsgInfo}
                                                        />
                                                    </div>

                                                    <button
                                                        type="button"
                                                        onClick={() => { updateAddressButtonClickedInfo() }}
                                                        className='font-hanken-grotesk text-[var(--modal-text-highlight)] md:text-[16px] sm:text-[13px] text-[13px] font-[700] bg-transparent border-0 cursor-pointer'
                                                    >
                                                        {t("save")}
                                                    </button>
                                                </div>
                                            }


                                        </div>
                                    </div>
                                </div>

                                <div className='flex flex-row sm:justify-end justify-between mb-16'>
                                    <button
                                        type="button"
                                        onClick={onBackClickedsevenClicked}
                                        className='font-hanken-grotesk text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] bg-transparent border-0 cursor-pointer'
                                    >
                                        {t("personal_back")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={finalAPIHit}
                                        disabled={isFinalStepClick}
                                        className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 bg-transparent border-0 ${isFinalStepClick ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                    >
                                        {t("Add Secondary Cardholder")}
                                    </button>
                                </div>
                            </>
                        )}
                    </DynamicCard>
                </div>
            </HomeLayout>
            {isLoading && <Loader />}
            <Modal
                isOpen={apisErrorModal}
                onClose={(e) => {
                    setApisErrorModal(false);
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("oops_exclamation")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={`${HeadingStyles} visible sm:hidden`}>
                            {t("oops_exclamation")}
                        </span>
                        <span className={SubHeadingStyles}>{showErrorMsg}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                        <ErrorModalForSSN ModalClose={handleSsnErrorCloseModal} showMainText={false}/>
                    </div>
                }
            />
            
            {/* SSN INFO SUCCESS MODAL */}
            <Modal
                isOpen={ssnSuccessModal}
                onClose={(e) => {
                    setSsnSuccessModal(false);
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("Success!")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={`${HeadingStyles} visible sm:hidden`}>
                            {t("ssn_success")}
                        </span>
                        <span className={SubHeadingStyles}>{t('SCH_SSN_SUCCESS')}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                        <SuccessModalForSSN ModalClose={handleSsnSuccessCloseClicked} />
                    </div>
                }
            />


            <Modal
                isOpen={isOpenGenerateMobileOtp}
                onClose={closeOTPVerifyModal}
                isLogo={false}
                title={<p className={HighlightMsgStyles}> {t('security_check')}</p>}
                subtitle={<><p className={HeaderMsgStyles}>{t('we_are_sending_messsage')}</p>  <p className="font-hanken-grotesk my-3 text-[var(--text-clr-transactions)]  lg:text-[20px] md:text-[18px] sm:text-[15px] text-[18px] leading-[30px] font-[500]  w-full">{t('standrd_message_rates_apply')}</p></>}
                content={<div className="mt-10"><Custom2FA selected2FAType={'Text'} type={'sch_mobile'} onClose={closeOTPVerifyModal} verificationFailure={verificationFaiure} verificationSuccess={verificationSuccess} /></div>}
            />


            <Modal
                isOpen={isOpenGenerateEmailOtp}
                onClose={closeOtpEmailVerifyModal}
                isLogo={false}
                title={<p className={HighlightMsgStyles}> {t('security_check')}</p>}
                subtitle={<><p className={HeaderMsgStyles}>{t('we_are_sending_email_message')}</p>  <p className="font-hanken-grotesk my-3 text-[var(--text-clr-transactions)]  lg:text-[20px] md:text-[18px] sm:text-[15px] text-[18px] leading-[30px] font-[500]  w-full">{t('standrd_message_rates_apply')}</p></>}
                content={<div className="mt-10"><Custom2FA selected2FAType={'Email'} type={'sch_email'} onClose={closeOtpEmailVerifyModal} verificationFailure={verificationEmailFailure} verificationSuccess={verficationEmailSuccess} /></div>}
            />

              {/* info custome2FA MODALS */}
              <Modal
                isOpen={isOpenInfoGenerateMobileOTPModal}
                onClose={closeOTPVerifyInfoModal}
                isLogo={false}
                title={<p className={HighlightMsgStyles}> {t('security_check')}</p>}
                subtitle={<><p className={HeaderMsgStyles}>{t('we_are_sending_messsage')}</p>  <p className="font-hanken-grotesk my-3 text-[var(--text-clr-transactions)]  lg:text-[20px] md:text-[18px] sm:text-[15px] text-[18px] leading-[30px] font-[500]  w-full">{t('standrd_message_rates_apply')}</p></>}
                content={<div className="mt-10"><Custom2FA selected2FAType={'Text'} type={'sch_mobile_update'} onClose={closeOTPVerifyInfoModal} verificationFailure={verificationFaiureInfo} verificationSuccess={verificationSuccessInfo} phoneNumber={selectedPohoneNumberInfo}/></div>}
            />

           
            <Modal
                isOpen={isOpenInfoGenerateEmailOTPModal}
                onClose={closeOtpEmailVerifyInfoModal}
                isLogo={false}
                title={<p className={HighlightMsgStyles}> {t('security_check')}</p>}
                subtitle={<><p className={HeaderMsgStyles}>{t('we_are_sending_email_message')}</p>  <p className="font-hanken-grotesk my-3 text-[var(--text-clr-transactions)]  lg:text-[20px] md:text-[18px] sm:text-[15px] text-[18px] leading-[30px] font-[500]  w-full">{t('standrd_message_rates_apply')}</p></>}
                content={<div className="mt-10"><Custom2FA selected2FAType={'Email'} type={'sch_email_update'} onClose={closeOtpEmailVerifyInfoModal} verificationFailure={verificationEmailFailureInfo} verificationSuccess={verficationEmailSuccessInfo} email={selectedEmailAdressInfo}/></div>}
            />

           {/* ERROR MODAL FOR GENERATE OTP */}
             <Modal
                isOpen={errorModalForGenerateOTP}
                onClose={(e) => {
                    setErrorModalForGenrateOTP(false);
                }}
                alignItems={"items-center"}
              isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("oops_exclamation")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={`${HeadingStyles} visible sm:hidden`}>
                            {t("oops_exclamation")}
                        </span>
                        <span className={SubHeadingStyles}>{showGenrateOTPErrorMessage}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                        <ErrorModalForSSN ModalClose={handlegGenerateOTPErrorCloseModal} showMainText={false}/>
                    </div>
                }
            />


             {/* SCH SUCCESS MODAL */}
             <Modal
                isOpen={showSCHSuccessModal}
                onClose={(e) => {
                    setShowSCHSuccessModal(false);
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("Success!")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={SubHeadingStyles}>{t('SCH_SUCCESS_SUB_TEXT')}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253  sm:mt-6 mt-6">
                        <SuccesModalForSCH ModalClose={handleSCHSuccessCloseClicked} />
                    </div>
                }
            />

             {/* ERROR MODAL FOR SCH CREATE */}
             <Modal
                isOpen={showFinalAPIErrorModal}
                onClose={(e) => {
                    setShowFinalAPIErrorModal(false);
                }}
                alignItems={"items-center"}
                isClimbg={false}
                title={
                    <p className={`${HeadingStyles} hidden sm:flex`}>
                        {t("oops_exclamation")}
                    </p>
                }
                subtitle={
                    <p>
                        <span className={`${HeadingStyles} visible sm:hidden`}>
                            {t("oops_exclamation")}
                        </span>
                        <span className={SubHeadingStyles}>{showFinalAPIErrorMessage}</span>
                    </p>
                }
                content={
                    <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
                        <ErrorModalForSSN ModalClose={handleCloseFinalAPIErrorModal} showMainText={false}/>
                    </div>
                }
            />
        </>
    )
}
export default withOidcSecure(AddSecondaryCardHolder);